<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div v-html="homePage.value" class="ck-content"></div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'home',
        mixins: [mixins],
        components: {
        },
        data: function () {
            return {
                homePage: {},
            }
        },
        computed: {

        },
        created() {
            this.loadHomePage();
        },
        mounted() {

        },
        methods: {
            loadHomePage() {
                var vm = this;
                vm.$services.get('system-parameters/config-home-pages').done((response) => {
                    vm.homePage = response || {}
                });
            }
        }
    }
</script>
